import React from 'react';
import PropTypes from 'prop-types';

const NavigationButtons = ({ currentStep, onPrevious, onNext, onSubmit }) => {
  const isFirstStep = currentStep === 1;
  const isLastStep = currentStep === 4;

  return (
    <div className="navigation-buttons">
      <button
        type="button"
        onClick={onPrevious}
        disabled={isFirstStep}
        className={`nav-btn prev-btn ${isFirstStep ? 'disabled' : ''}`}
      >
        Previous
      </button>
      
      {isLastStep ? (
        <button
          type="button"
          onClick={onSubmit}
          className="nav-btn submit-btn"
        >
          Submit Listing
        </button>
      ) : (
        <button
          type="button"
          onClick={onNext}
          className="nav-btn next-btn"
        >
          Next
        </button>
      )}
    </div>
  );
};

NavigationButtons.propTypes = {
  currentStep: PropTypes.number.isRequired,
  onPrevious: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
};

export default NavigationButtons;
